import "antd/dist/antd.css";
import "../App.css";

import { Link } from "react-router-dom";
import { TERMS_LAST_UPDATED_DISPLAY } from "../termsVersion";
import usePageMeta from "../usePageMeta";

function Terms() {
    const lastUpdated = TERMS_LAST_UPDATED_DISPLAY;
    usePageMeta({
        title: "Terms of Service — Planamoto",
        description: "Terms governing your use of Planamoto.",
        url: "https://www.planamoto.com/terms",
    });

    return (
        <article className="gt-legal-page">
            <div className="gt-card gt-legal-page__card">
                <div className="gt-eyebrow">Legal</div>
                <h1 className="gt-h2 gt-legal-page__title">
                    Terms of service
                </h1>
                        <div
                            className="gt-body-sm"
                            style={{
                                color: "var(--gt-text-muted)",
                                marginBottom: 16,
                            }}
                        >
                            Last updated {lastUpdated}
                        </div>

                        <p>
                            These terms govern your use of Planamoto, a tour planning
                            service ("the Service"). By creating an account or using the
                            Service you agree to these terms.
                        </p>

                        <h3>1. Eligibility and accounts</h3>
                        <p>
                            You must be at least 16 years old to use Planamoto. You are
                            responsible for safeguarding your password and for any activity
                            on your account. Notify us immediately if you believe your
                            account has been used without your permission.
                        </p>

                        <h3>2. Your content</h3>
                        <p>
                            You retain ownership of the tour data, itineraries, expenses,
                            participants, and notes you add to the Service ("Your Content"). You
                            grant us a limited licence to host, store, and process Your
                            Content solely to provide the Service to you and the participants you
                            invite.
                        </p>
                        <p>
                            You are responsible for the accuracy of Your Content and for
                            having permission to share participant names and other details with
                            other users of your tour.
                        </p>

                        <h3>3. Acceptable use</h3>
                        <p>You agree not to:</p>
                        <ul>
                            <li>Use the Service for unlawful purposes;</li>
                            <li>
                                Upload content that infringes others' rights or contains
                                malware;
                            </li>
                            <li>
                                Attempt to disrupt, reverse-engineer, or gain unauthorised
                                access to the Service or its underlying infrastructure;
                            </li>
                            <li>
                                Use automated tools to scrape or extract data beyond what is
                                made available through the normal user interface.
                            </li>
                        </ul>

                        <h3>4. AI features</h3>
                        <p>
                            Planamoto offers optional AI-assisted features (for example,
                            itinerary enrichment and location briefs). AI output may be
                            inaccurate, incomplete, or unsafe — always verify route, weather,
                            border, and safety information from authoritative sources before
                            touring. The Service is not a substitute for professional advice.
                        </p>

                        <h3>5. Third-party data and outbound links</h3>
                        <p>
                            The Service displays data from third parties such as weather
                            forecasts, exchange rates, and map providers. We do not control
                            and are not responsible for the accuracy, availability, or
                            licensing of third-party data.
                        </p>
                        <p>
                            The Service also includes outbound links to third-party booking
                            and shopping sites. Some of these are affiliate links and may
                            earn us a small commission at no extra cost to you. See our{" "}
                            <Link to="/privacy">privacy policy</Link> for details. We are not
                            responsible for the content, terms, or fulfilment of any
                            third-party site you transact with.
                        </p>

                        <h3>6. Disclaimers</h3>
                        <p>
                            The Service is provided "as is" and "as available" without
                            warranties of any kind. We do not warrant that the Service will
                            be uninterrupted, error-free, or fit for any particular purpose.
                            Touring carries inherent risk that you accept; you are solely
                            responsible for your route choices, equipment, and touring
                            decisions.
                        </p>

                        <h3>7. Limitation of liability</h3>
                        <p>
                            To the fullest extent permitted by law, Planamoto and its
                            operators will not be liable for any indirect, incidental,
                            consequential, or special damages arising out of or in
                            connection with your use of the Service. Nothing in these terms
                            limits liability for fraud, death, or personal injury caused by
                            negligence, or any other liability that cannot be excluded under
                            applicable law.
                        </p>

                        <h3>8. Termination</h3>
                        <p>
                            You may delete your account at any time. We may suspend or
                            terminate access to the Service if you breach these terms or if
                            we discontinue the Service. On termination your right to use
                            the Service ends immediately; clauses that by their nature
                            should survive (including disclaimers and liability limits)
                            will remain in force.
                        </p>

                        <h3>9. Changes to these terms</h3>
                        <p>
                            We may update these terms from time to time. If we make a
                            material change we will let you know through the Service or by
                            email. Continued use after the change takes effect means you
                            accept the updated terms.
                        </p>

                        <h3>10. Governing law</h3>
                        <p>
                            These terms are governed by the laws of England and Wales, and
                            the courts of England and Wales have exclusive jurisdiction over
                            any disputes, except where applicable consumer law provides
                            otherwise.
                        </p>

                        <h3>11. Contact</h3>
                        <p>
                            Questions about these terms? Email{" "}
                            <a href="mailto:support@planamoto.com">
                                support@planamoto.com
                            </a>
                            .
                        </p>

                <div className="gt-body-sm" style={{ textAlign: "center", marginTop: 24 }}>
                    <Link to="/login">Back to sign in</Link>
                </div>
            </div>
        </article>
    );
}

export default Terms;
